const { movePhotoByOffset, movePhotoToken } = require('./photo-order-utils');
/** Ordered photo state. Keys are stable client identities, never array positions. */
export function createPhotoCollection() {
    let items = [];
    return {
        getItems: () => items.slice(),
        setItems(next, preserveOrder = true) {
            const keys = next.map(item => item.key);
            if (keys.some(key => !key) || new Set(keys).size !== keys.length) throw new Error('Photo keys must be unique and nonempty');
            const byKey = new Map(next.map(item => [item.key, item]));
            const retained = preserveOrder ? items.filter(item => byKey.has(item.key)).map(item => byKey.get(item.key)) : [];
            const retainedKeys = new Set(retained.map(item => item.key));
            items = retained.concat(next.filter(item => !retainedKeys.has(item.key)));
        },
        move(key, offset) {
            const index = items.findIndex(item => item.key === key);
            const target = index + offset;
            if (index < 0 || target < 0 || target >= items.length) return false;
            const byKey = new Map(items.map(item => [item.key, item]));
            items = movePhotoByOffset(items.map(item => item.key), key, offset).map(key => byKey.get(key));
            return true;
        },
        drop(key, target, after) {
            if (key === target || !items.some(item => item.key === target)) return false;
            const source = items.find(item => item.key === key);
            if (!source) return false;
            const byKey = new Map(items.map(item => [item.key, item]));
            items = movePhotoToken(items.map(item => item.key), key, target, after).map(key => byKey.get(key));
            return true;
        },
    };
}
